<template>
    <div>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            Class Course
                        </th>
                        <th class="text-left">
                            Class Time
                        </th>
                        <th class="text-left">
                            Reason
                        </th>
                        <th>
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="request in requests" :key="request.id">
                        <td class="py-3">
                            <div class="d-flex align-center">
                                <router-link class="me-3" :to="{name: 'course', params: {id: request.enrollment.course.id}}">
                                    <v-avatar tile width="60" height="50" style="border-radius: 5px!important" v-ripple="{class: 'black--text'}">
                                        <v-img :src="request.enrollment.course.image_url" />
                                    </v-avatar>
                                </router-link>
                                <div>
                                    <div class="strong-text--text nowrap mb-1 font-weight-medium">{{request.enrollment.course.name}}</div>
                                    <div>
                                        <v-chip class="font-weight-medium" text small label>
                                            Sent to: {{request.receiver.name}}
                                        </v-chip>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <v-chip color="red" text class="red lighten-5 red--text text--darken-2 font-weight-bold">
                                <v-icon left>mdi-clock-outline</v-icon>
                                <span>{{request.class_start_formated}}</span>
                            </v-chip>
                        </td>
                        <td>
                            <v-btn v-if="request.reason" @click="openReasonDialog(request)">
                                <v-icon left>mdi-text</v-icon>
                                <span style="text-transform: none">Show Reason</span>
                            </v-btn>
                            <span v-else>No Reason</span>
                        </td>
                        <td style="white-space: nowrap;">
                            <v-btn color="red" dark @click="showWithdrawDialog(request)">
                                <v-icon left size="18">mdi-close-circle-outline</v-icon>
                                Withdraw
                            </v-btn>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-dialog v-model="reasonDialog" max-width="350">
            <v-card>
                <v-card-title>
                    <v-icon class="me-2">mdi-text</v-icon>
                    <span>Reason</span>
                </v-card-title>
                <v-card-text class="text--text">
                    <div v-if="reasonItem && reasonItem.reason" style="white-space: pre-line;">{{reasonItem.reason}}</div>
                </v-card-text>
                <v-btn absolute top right icon color="muted" @click="reasonDialog = false;">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card>
        </v-dialog>

        <v-dialog v-model="withdrawDialog" max-width="350">
            <v-card>
                <v-card-title>Withdraw Cancellation Request</v-card-title>
                <v-card-text>
                    Are you sure you want to withdraw this cancellation request? The class will remain scheduled.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="withdrawing" @click="withdrawDialog = false">Close</v-btn>
                    <v-btn :loading="withdrawing" :disabled="withdrawing" text color="red" @click="withdrawRequest()">Withdraw</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        requests: Array
    },
    data(){
        return {
            withdrawing: false,
            withdrawRequestId: null,
            withdrawDialog: false,

            reasonDialog: false,
            reasonItem: null,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,

        openReasonDialog(request){
            this.reasonItem = request;
            this.reasonDialog = true;
        },
        showWithdrawDialog(request){
            this.withdrawRequestId = request.id;
            this.withdrawDialog = true;
        },
        withdrawRequest(){
            if (!this.withdrawing){
                this.withdrawing = true;
                return this.$store.dispatch('withdrawMyCancelationRequest', {id: this.withdrawRequestId}).then(response=>{
                    this.withdrawing = false;
                    this.withdrawDialog = false;
                    this.showMsg('Cancellation request withdrawn', 'success');
                    this.$emit('load');
                }).catch(error=>{
                    this.withdrawing = false;
                    this.showMsg('Error occurred during performing your action', 'error');
                })
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
